import cheerio from 'cheerio';
import { shuffle, getParams } from './util';
import conf from '../js/conf.json';

const SCORE_INCREMENT = conf.scoreIncrement;
const COMBO_BONUS = conf.comboBonus;

const QUESTION_URL = conf.questionURL;
const SAVE_URL = conf.saveURL;

const AC = typeof AudioContext !== "undefined" ? AudioContext : (typeof webkitAudioContext !== "undefined" ? webkitAudioContext : null);

export default class API {
  constructor () {
    this.loaded = false;
    this.xmlResponse = null;
    this.questions = [];
    this.rightAnswer = null;

    if (AC) {
      console.log(AC);
      this.audioContext = new AC();

      loadSound(this.audioContext, require("../snd/yeah.mp3"), buffer => this.correctBuffer = buffer);
      loadSound(this.audioContext, require("../snd/fail.mp3"), buffer => this.wrongBuffer = buffer);
      loadSound(this.audioContext, require("../snd/end.mp3"), buffer => this.endBuffer = buffer);
    }

    this.reset();
  }

  loadQuestions(){
    const xhr = new XMLHttpRequest();

    return new Promise((resolve, reject) => {
      xhr.onreadystatechange = () => {

        if(xhr.readyState == 4) {
          if(xhr.status == 200) {
            this.xmlResponse = xhr.responseText.substr(5);
            this.parseQuestions();
            this.loaded = true;
            resolve();
          }
          else {
            reject();
          }
        }
      };

      xhr.open("GET", QUESTION_URL);
      xhr.send();
    });
  }

  parseQuestions () {
    const $ = cheerio.load(this.xmlResponse);
    const tags = $("user");

    this.questions = tags.map(function (index, tag) {
      var $tag = $(tag);
      return {
        text: $tag.attr("tm"),
        answers: [
          $tag.attr("right"), // First in array is always correct
          $tag.attr("wrong1"),
          $tag.attr("wrong2")
        ],
        correct: $tag.attr("right") // Might as well save it here too
      };
    }).toArray();
  }

  nextQuestion() {
    if(!this.loaded){
      return null;
    }

    if(this.hasMoreQuestions()){
      this.questionNumber++;

      const q = this.questions[this.questionNumber];

      this.answers = q.answers.slice(); // Shuffle is in place so take clone
      this.rightAnswer = q.answers[0];

      shuffle(this.answers);

      return {
        text: q.text,
        answers: this.answers
      }
    }
  }

  answerQuestion(index) {
    const submission = this.answers[index];
    const correct = submission == this.rightAnswer;

    this.questions[this.questionNumber].submission = submission;

    if(correct) {
      this.score += SCORE_INCREMENT + this.combo * COMBO_BONUS;
      this.correctAnswers++;
      this.combo++;
      playSound(this.audioContext, this.correctBuffer);
    }
    else {
      this.combo = 0;
      this.score -= SCORE_INCREMENT;
      this.score = Math.max(this.score, 0);
      this.wrongAnswers++;
      playSound(this.audioContext, this.wrongBuffer);
    }

    return correct;
  }

  hasMoreQuestions() {
    return this.questionNumber < (this.questions.length - 1);
  }

  getQuestions() {
    return this.questions;
  }

  reset () {
    this.questionNumber = -1;
    this.score = 0;
    this.combo = 0;
    this.correctAnswers = 0;
    this.wrongAnswers = 0;
  }

  saveResult () {
    const xhr = new XMLHttpRequest();

    const params = getParams(window.location.search);

    const userId = params['id'];
    const aid = params['aid'];
    const lateSubmit = params['late_submit'];

    const correctAnswers = this.correctAnswers;

    xhr.open("POST", SAVE_URL);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(`id=${userId}&score=${correctAnswers}&aid=${aid}&late_submit=${lateSubmit}`);
    playSound(this.audioContext, this.endBuffer);
  }
}

function loadSound (context, file, callback) {
  if (context) {
    console.log(context);
    var request = new XMLHttpRequest();
      
    request.open("GET", file, true);
    request.responseType = "arraybuffer";
    request.onload = function(){
        context.decodeAudioData(request.response, callback);
    }
    
    request.send();
  }
}

function playSound (context, buffer) {
  if (context) {
    var bufferSource = context.createBufferSource();
    bufferSource.buffer = buffer;
    bufferSource.connect(context.destination);
    bufferSource.start();
  }
}


// WEBPACK FOOTER //
// ./src/js/api.js